import React, { useState } from 'react';
import StageCard from '../components/StageCard';
import FinalDocument from '../components/FinalDocument';
import WelcomeScreen from '../components/WelcomeScreen';
import { STAGES } from '../data/stages';
import { api } from '../services/api';

// FIX: Ensure global replacement for SQL date formatting
const getFormattedDate = () => new Date().toISOString().slice(0, 19).replace(/T/g, ' ');

export default function Ritual() {
  const [view, setView] = useState('welcome');
  const [currentStep, setCurrentStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const [appUserId, setAppUserId] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleWelcomeSubmit = async (userData) => {
    setIsSubmitting(true);
    try {
      const res = await api.createUser({
        user_name: userData.name,
        email: userData.email
      });
      if (res && res.id) {
        setAppUserId(res.id);
        setView('ritual');
      }
    } catch (error) {
      console.error("User registration failed:", error);
      setAppUserId('temp_' + Date.now());
      setView('ritual');
    } finally {
      setIsSubmitting(false);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleNext = async (stageId, value) => {
    setIsSubmitting(true);
    try {
      if (stageId === 'domain') {
        const res = await api.createSession({
          app_user_id: appUserId,
          goal_domain: value,
          created_at: getFormattedDate()
        });
        if (res && res.id) setSessionId(res.id);
      } else {
        if (sessionId) {
          await api.createStageResponse({
            session_id: sessionId,
            stage_number: currentStep,
            stage_name: STAGES[currentStep].title,
            user_response: value,
            created_at: getFormattedDate()
          });
        }
      }
    } catch (error) {
      console.error("Failed to sync with backend:", error);
    } finally {
      setIsSubmitting(false);
      setAnswers(prev => ({ ...prev, [stageId]: value }));
      
      if (currentStep < STAGES.length - 1) {
        setCurrentStep(prev => prev + 1);
      } else {
        setView('complete');
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  if (view === 'welcome') {
    return <WelcomeScreen onProceed={handleWelcomeSubmit} isSubmitting={isSubmitting} />;
  }

  if (view === 'complete') {
    return (
      <div className="max-w-4xl mx-auto">
        <FinalDocument answers={answers} />
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto">
      <div className="mb-8 text-center text-xs font-mono text-neutral-600">
        STAGE {currentStep} OF {STAGES.length - 1}
      </div>
      <StageCard 
        stage={STAGES[currentStep]} 
        answers={answers} 
        onNext={handleNext} 
        isSubmitting={isSubmitting} 
      />
    </div>
  );
}